<template>
  <VpRequest :get="get" class="vp-h-full vp-overflow-hidden">
    <template #default="{ res }">
      <VpSubShell>
        <template #before-nav>
          <div class="vp-p-4">
            <VpMedia :value="res.profilePicture" size="1x1" />

            <div class="vp-mt-6">
              <VpField label="Card">
                <h4 class="vp-leading-none vp-text-lg vp-font-bold">
                  {{ res.name }}
                </h4>
              </VpField>
            </div>
          </div>
        </template>

        <template #nav>
          <VpSubNavItem
            exact
            label="Profile"
            :icon="$options.icons.Info"
            :to="{
              name: 'card',
            }"
          />

          <VpSubNavItem
            label="Contacts"
            :icon="$options.icons.ContactBook"
            :to="{ name: 'contacts' }"
          />

          <VpSubNavItem
            label="Links"
            :icon="$options.icons.Link"
            :to="{ name: 'links' }"
          />
          <VpSubNavItem
            label="Social Links"
            :icon="$options.icons.Twitter"
            :to="{ name: 'social-links' }"
          />

          <VpSubNavItem
            label="Visit Your Card"
            :icon="$options.icons.OpenInNew"
            :href="res.subdomainUrl"
            target="cards_preview"
          />
        </template>
      </VpSubShell>
    </template>
  </VpRequest>
</template>

<script>
import get from "./get.gql";
import {
  Twitter,
  Info,
  ContactBook,
  OpenInNew,
  Link,
  Whatsapp,
} from "icons/icons.js";

export default {
  icons: {
    History,
    Info,
    ContactBook,
    Twitter,
    Document,
    OpenInNew,
    Link,
    Notification,
    Whatsapp,
  },

  methods: {
    get() {
      return this.$query(get, {
        id: Number(this.$route.params.cardId),
      }).then(({ data }) => {
        return data.card;
      });
    },
  },
};
</script>
